import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CgClose } from "react-icons/cg";
import Button from "./button";
import "./TaskDetails.css";
import "./modal.css";

const TaskDetails = ({ Details, HandleDetailsChange, tasks }) => {
  const params = useParams();
  const history = useNavigate();

  const HandleBackButtonCllick = () => {
    history("/TaskList");
  };

  const OpenModal = () => {
    var modal = document.querySelector(".modal");
    modal.classList.add("show-modal");
  };

  const CloseModal = () => {
    var modal = document.querySelector(".modal");
    modal.classList.remove("show-modal");
  };

  const HandleSaveButton = () => {
    CloseModal()
    let x = document.querySelector("#NewDetails");
    let task = tasks.filter(task => task.details === Details);
    HandleDetailsChange(x.value, task[0].id);
  };

  return (
    <>
      <div className="back-button-container">
        <Button onClick={HandleBackButtonCllick}>Voltar</Button>
      </div>
      <div className="task-details-container">
        <h2>{params.taskTitle}</h2>
        <p>{Details}</p>
        <Button onClick={OpenModal}>Editar</Button>
      </div>
      <div className="modal" id="modal">
        <div className="modal-content">
          <span className="close-button" onClick={CloseModal}>
            <CgClose />
          </span>
          <div id="his">
            <textarea
              name="NewDetails"
              id="NewDetails"
              cols="60"
              rows="10"
              placeholder="Digite seu texto aqui"
            ></textarea>
            <Button onClick={HandleSaveButton}>Salvar</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskDetails;
